import { useState } from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useSeo } from '@/hooks/useSeo';

const PRINCIPLES = [
  { icon: 'ri-flashlight-line', title: '极速更新', desc: '热点发生后的第一时间跟进，力争在热度最高的时候把最完整的信息送到你面前。' },
  { icon: 'ri-scales-3-line', title: '多方核验', desc: '对每一条爆料进行多来源交叉验证，标注信息出处，避免以讹传讹。' },
  { icon: 'ri-eye-line', title: '理性吃瓜', desc: '区分事实与传闻，呼吁网友理性看待，尊重当事人隐私与合法权益。' },
  { icon: 'ri-time-line', title: '时间线复盘', desc: '把零散的信息整理成完整时间线，让每一个大瓜都能看得明白、追得清楚。' },
];

const CONTACTS = [
  { label: '商务合作', value: 'business@gossip-demo.com', icon: 'ri-briefcase-line' },
  { label: '内容爆料', value: 'tip@gossip-demo.com', icon: 'ri-send-plane-line' },
  { label: '用户反馈', value: 'support@gossip-demo.com', icon: 'ri-customer-service-2-line' },
];

export default function AboutPage() {
  const [toast, setToast] = useState('');

  useSeo({
    title: '关于我们-黑料网曝大瓜',
    description: '了解黑料网曝大瓜的网站定位、内容范围与更新原则，以及我们的联系方式。我们专注于明星八卦与娱乐爆料资讯。',
    keywords: '关于我们,黑料网曝大瓜,娱乐爆料,明星八卦,娱乐资讯',
  });

  const copy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      setToast('已复制：' + value);
    } catch {
      setToast('复制失败，请手动复制：' + value);
    }
    setTimeout(() => setToast(''), 2200);
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />

      <main className="w-full">
        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 pt-8">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">关于我们</span>
          </nav>

          <div className="rounded-xl bg-primary-950 text-background-50 p-8 md:p-14">
            <span className="font-label text-xs tracking-[0.25em] text-secondary-400 uppercase">About Us</span>
            <h1 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl max-w-3xl leading-tight">黑料网曝大瓜</h1>
            <p className="mt-5 text-sm md:text-base text-primary-100/80 leading-relaxed max-w-3xl">
              我们是一个专注于明星八卦与娱乐爆料资讯的内容平台，致力于用最快的速度、最清晰的结构，把娱乐圈里正在发生的一切讲给你听。
            </p>
          </div>
        </section>

        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div>
              <div className="flex items-center gap-3 mb-5">
                <span className="w-1.5 h-7 rounded-full bg-primary-500" />
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">网站定位</h2>
              </div>
              <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-8">
                <p>
                  黑料网曝大瓜面向广大娱乐新闻爱好者，以及习惯追踪明星动态的网民。无论你是想看最新的明星绯闻，还是想系统了解某个热门话题的来龙去脉，这里都能找到你想要的答案。
                </p>
                <p>
                  我们不是简单的信息搬运工，而是希望成为你身边的“八卦编辑”——把分散在各处的线索整理清楚，用更容易理解的方式呈现给每一位吃瓜群众。
                </p>
              </div>
            </div>

            <div>
              <div className="flex items-center gap-3 mb-5">
                <span className="w-1.5 h-7 rounded-full bg-accent-500" />
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">内容范围</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  { t: '明星绯闻', d: '恋情、分手、婚姻与私下同框的实时追踪。' },
                  { t: '最新新闻', d: '影视、综艺、音乐与商业代言等官方动态。' },
                  { t: '热门爆料', d: '独家内幕、圈内风向与幕后花絮。' },
                  { t: '专题合集', d: '年度复盘、塌房观察与深度专题报道。' },
                ].map((c) => (
                  <div key={c.t} className="rounded-lg border border-background-200 bg-background-50 p-4">
                    <h3 className="font-heading font-semibold text-sm text-foreground-950">{c.t}</h3>
                    <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">{c.d}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 border-y border-background-200">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-14">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-1.5 h-7 rounded-full bg-secondary-500" />
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">更新原则</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {PRINCIPLES.map((p, i) => (
                <div key={p.title} className="rounded-lg bg-background-50 border border-background-200 p-5">
                  <span className={`w-11 h-11 flex items-center justify-center rounded-lg text-xl ${i % 2 === 1 ? 'bg-secondary-100 text-secondary-800' : 'bg-primary-50 text-primary-600'}`}>
                    <i className={p.icon} />
                  </span>
                  <h3 className="mt-4 font-heading font-semibold text-base text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-1.5 h-7 rounded-full bg-primary-500" />
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">联系方式</h2>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                欢迎通过以下方式与我们取得联系。点击邮箱地址即可一键复制。
              </p>
              <div className="mt-5 flex items-center gap-2">
                {['ri-weibo-fill', 'ri-wechat-fill', 'ri-tiktok-fill'].map((icon) => (
                  <span key={icon} className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer">
                    <i className={`${icon} text-lg`} />
                  </span>
                ))}
              </div>
            </div>

            <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {CONTACTS.map((c) => (
                <button
                  key={c.label}
                  type="button"
                  onClick={() => copy(c.value)}
                  className="text-left rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors cursor-pointer"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${c.icon} text-lg`} />
                  </span>
                  <h3 className="mt-3 font-heading font-semibold text-sm text-foreground-950">{c.label}</h3>
                  <p className="mt-1 text-xs text-foreground-500 break-all">{c.value}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary-600">
                    <i className="ri-file-copy-line" /> 点击复制
                  </span>
                </button>
              ))}
            </div>
          </div>

          <p className="mt-10 text-xs text-foreground-400 leading-relaxed max-w-3xl">
            说明：本站为产品设计演示站点，页面中的资讯、人物、事件与联系方式均为虚构示例，不涉及任何真实主体。所有功能（搜索、筛选、分享）均为前端模拟演示。
          </p>
        </section>
      </main>

      {toast && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 px-5 py-3 rounded-lg bg-foreground-950 text-background-50 text-sm anim-fade-up">
          {toast}
        </div>
      )}

      <SiteFooter />
    </div>
  );
}